import api from "../config/api";

import {
  ServicePaginatedReturn,
  ServiceReturn,
} from "../types/ServiceResponse";

import { Log } from "../models/Log";

export interface GetLogsPayload {
  page?: number;
  perPage?: number;
};

const moduleBaseUrl = "log";

export const getLogs = async ({ page = 1, perPage = 10 }: GetLogsPayload, token?: string ): Promise<ServicePaginatedReturn<Log>> => {
  try {
    const {
      data
    } = await api.get(`/${ moduleBaseUrl }`, {
      headers: {
        Authorization: `Bearer ${ token }`,
      },
      params: {
        page,
        perPage,
      }
    });

    return data;
  } catch ( error: any ) {
    return {
      data: false,
      message: error?.response?.data?.message ?? error?.message,
    };
  }
};

export const deleteLog = async ( id: string, token?: string ): Promise<ServiceReturn<boolean>> => {
  try {
    const {
      data
    } = await api.delete(`/${ moduleBaseUrl }/${ id }`, {
      headers: {
        Authorization: `Bearer ${ token }`,
      }
    });

    return data;
  } catch ( error: any ) {
    return {
      data: false,
      message: error?.response?.data?.message ?? error?.message,
    };
  }
};
